import { render, staticRenderFns } from "./AvidiaFooterCash.vue?vue&type=template&id=4a77bab1&scoped=true"
import script from "./AvidiaFooterCash.vue?vue&type=script&lang=ts"
export * from "./AvidiaFooterCash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77bab1",
  null
  
)

export default component.exports